function ChapterThesis({ parallaxY }) {
  return (
    <section id="manifesto" className="chapter thesis-section" data-section="manifesto" data-testid="chapter-01-thesis">
      <div className="chapter-intro">
        <div className="section-kicker"><span>01</span><span>THE OPERATING THESIS</span></div>
        <div><h2 data-testid="chapter-01-heading">Architecture over dogma.</h2><p className="chapter-lead">The strongest systems are not the ones with the most moving parts. They are the ones that make the right outcome feel inevitable.</p></div>
      </div>
      <div className="thesis-grid">
        <div className="thesis-copy">
          <p>Across engineering, solution design, customer discovery, and technical advocacy, I look for the same thing: a clear line between a difficult problem and a better way forward.</p>
          <div className="quote-monolith">
            <span className="quote-watermark" aria-hidden="true" style={{ transform: `translate3d(0, ${parallaxY}px, 0)` }}>MAKE IT MATTER</span>
            <blockquote>“Technology earns its place when it gives people more room to think, decide, and move.”</blockquote>
            <span className="quote-credit">— ARMAND MAZALAN / PRACTICE NOTE 01</span>
          </div>
        </div>
        <aside className="metric-stack" aria-label="Professional highlights">
          <div className="metric-block"><strong data-testid="metric-years-experience">10+</strong><span>YEARS ACROSS ENGINEERING, CLOUD, AND CUSTOMER-FACING DELIVERY</span></div>
          <div className="metric-block"><strong data-testid="metric-enterprise-deployments">6</strong><span>PROFESSIONAL CERTIFICATIONS ACROSS CLOUD, AI, AND INTEGRATION</span></div>
          <div className="metric-block"><strong data-testid="metric-certifications">4</strong><span>CONNECTED DISCIPLINES: BUILD, INTEGRATE, EXPLAIN, ENABLE</span></div>
        </aside>
      </div>
    </section>
  );
}

export default ChapterThesis;
